module.exports = __webpack_public_path__ + "447bd9ec307612933bf5750b6430aff6.svg";